package dk.rheasoft.csaware.api.incident

import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.Serializer
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

@Serializable(with = ThreatState.ThreatStateSerializer::class)
enum class ThreatState(val active: Boolean = false) {
    Active(true),
    Resolved,
    Ignored,
    Unknown;

    companion object {
        fun parse(value: String): ThreatState = try {
            valueOf(value)
        } catch (_: Throwable) {
            Unknown
        }
    }

    @Serializer(forClass = ThreatState::class)
    object ThreatStateSerializer : KSerializer<ThreatState> {
        override fun deserialize(decoder: Decoder): ThreatState {
            return try {
                valueOf(decoder.decodeString())
            } catch (e: IllegalArgumentException) {
                Unknown
            }
        }

        override fun serialize(encoder: Encoder, value: ThreatState) {
            encoder.encodeString(value.name)
        }
    }

}